import "rxjs/add/operator/map";
import { Component } from '@angular/core';
import { EventSpeakerPage } from '../../pages/event-speaker/event-speaker';
import { NavParams, NavController, Events } from 'ionic-angular';
import { EventData } from '../../providers/event';
import { Observable} from 'rxjs/Observable';

@Component({
  selector: 'event-speaker',
  templateUrl: 'event-speaker.html'
})
export class EventSpeakerComponent {

  obs: any;
  obsSpeaker: any;
  obsRelatedSpeaker: any;
  obsListener: any;
  event: any;
  client: string;
  componentState: boolean = false;
  dataSpeaker: any = [];

  constructor(public eventProvider: EventData, public params: NavParams, public navCtrl: NavController, events: Events) {
    this.event = this.params.get('event');
    this.client = this.params.get('client');

    this.obsListener = this.eventProvider.getListener(this.client, this.event.id, 'speaker').subscribe(stateModule => {
      if (stateModule.$value === true) {
        this.componentState = true;
      } else {
        this.componentState = false;
      }
    });

    this.obs = new Observable(observer => {
      this.obsSpeaker = this.eventProvider.getListSpeaker(this.client, this.event.id).subscribe((data: any) => {
        if (data && this.componentState) {
          observer.next(data);
        } else {
          observer.next(false);
        }
      });
    });

    this.obs.subscribe((value) => {
      this.dataSpeaker = [];

      if (this.obsRelatedSpeaker) {
        this.obsRelatedSpeaker.unsubscribe();
      }

      if (value) {
          value.forEach((speaker: any, key) => {

            if (speaker.state == true) {
              this.obsRelatedSpeaker = this.eventProvider.getSpeaker(this.client, speaker.speakerId).subscribe((data: any) => {
                let tmp = data;
                tmp.state = speaker.data;
                tmp.order = speaker.order;
                this.dataSpeaker.push(tmp)
              });
            }
          });
      } else {
        this.dataSpeaker = [];
      }
    });

    // close de listener where logout user
    events.subscribe('client:logout', (r) => {
      this.closeListener();
    });
  }


  viewSpeaker(speaker) {
    this.navCtrl.push(EventSpeakerPage, {speaker: speaker, event: this.event, client: this.client});
  }

  closeListener() {
    if (this.obsListener) {
      console.log('Se eliminan los observables de Speaker');
      this.obsListener.unsubscribe();
    }
    if (this.obsSpeaker) {
      this.obsSpeaker.unsubscribe();
    }
    if (this.obsRelatedSpeaker) {
      this.obsRelatedSpeaker.unsubscribe();
    }
  }

  // Unsubsucribe observables on exit page
  ngOnDestroy() {
    this.closeListener();
  }
}
// end file



// WEBPACK FOOTER //
// ./src/components/event-speaker/event-speaker.ts